
import { LoginContract } from './LoginContract';
export class User {
  public LID: number;
  public EncLID: string;
  public LogonID: string;
  public Password: string;
  public ConfirmPassword: string;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public Phone: string;
  public Fax: string;
  public Status: string;
  public DateCreated: Date;
  public DateUpdated: Date;
  public UserType: string;
  public PrivacyDate: Date;
  public UpdateOptionShown: boolean;
  public QuestionID: number;
  public Answer: string;
  public DefaultPayType: string;
  public DefaultPayID: number;
  public CompanyName: string;
  public Title: string;
  public get FullName(): string {
    return this.FirstName + ' ' + this.LastName;
  }
  public OptoutType: string;
  public OptoutComments: string;
  public isAMPUser: boolean;
  public isAllianceUser: boolean;
  public AllianceUsername: string;
  public AlliancePassword: string;
  public AMPPassword: string;
  public NAPaymentVisible: boolean;
  public Contracts: LoginContract[];
  public ContractUserStatus: string;
  public UniversalEmail: string;
  public UniversalGuid: string;
  public universalFlag: boolean;
  public bearerToken = '';
  public id: string;
  public userRoleID:number;

}



// WEBPACK FOOTER //
// ./src/app/models/User.ts